// extracted by mini-css-extract-plugin
module.exports = {"siteSecondaryNav":"secondary-nav_siteSecondaryNav__pW2tH","siteSecondaryList":"secondary-nav_siteSecondaryList__tcI_3"};